import React, { useState } from 'react'


import { Button, Menu, Modal } from 'antd'
import { ArrowsAltOutlined, ShrinkOutlined } from '@ant-design/icons'
import { MenuItem } from '../../Models/ModalItem'


interface Props{
    menuItem:MenuItem
    open:boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    updateSize?: boolean
    size?: "normal" | "big"


}

const ModalMenuItem = ({menuItem, open, setOpen, updateSize, size}:Props) => {


    const closeModal= ()=>{
        setOpen(false)
    }

  const componentChild = React.cloneElement(menuItem.component, {closeModal:closeModal}) 

  return (
    <>
        {
        <Modal centered width={size==="normal" ? 400  :1000} open={open} onCancel={()=>{setOpen(false)}} title={menuItem.title} footer={false} afterClose={()=>{menuItem.onConfirm()}} destroyOnClose >
            {componentChild}

            {/* {updateSize && <div style={{display:"flex", flexDirection:"row", flexWrap:"nowrap", justifyContent:"end"}}> <Button onClick={()=>{setSize(size==="normal" ? 'big' : "normal")}} type='primary' style={{padding:"0", marginTop:"5px"}}> {size==="normal" ? <ArrowsAltOutlined style={{fontSize:"15px"}} /> :<ShrinkOutlined style={{fontSize:"15px"}} /> } </Button></div>} */}

        </Modal>
        }

    </>
  )
}

export default ModalMenuItem